import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface OfflineMessageContainerProps {
  children: React.ReactNode;
}

const ContainerComponent: React.FC<OfflineMessageContainerProps> = ({
  children,
}) => {
  return <div className="peptalk-offline-message">{children}</div>;
};

export const Container: React.FC<OfflineMessageContainerProps> = (
  props: OfflineMessageContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'OfflineMessageContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
